import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core"

@Component({
  selector: "icon-text",
  templateUrl: "./icon-text.component.html",
  styleUrls: ["./icon-text.component.css"],
})
export class IconTextComponent implements OnInit {
  @Input() iconSrc: string = undefined
  @Input() iconWidth: number = undefined
  @Input() forceIcon: boolean = false
  
  title = ""
  iconUrl = ""

  @ViewChild("contentWrapper") content: ElementRef

  ngOnInit(): void {
    this.title = this.content?.nativeElement?.textContent ?? ""
  }
}
